import React, { useState } from 'react';
import { Dialog, DialogContent, TextField, Button, Grid, IconButton, Typography, Box, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { sendEmail } from '../utils/emailService';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const fieldSx = {
  '& .MuiOutlinedInput-root': {
    bgcolor: '#0F1117', borderRadius: '10px',
    '& fieldset': { borderColor: 'rgba(255,255,255,0.08)' },
    '&:hover fieldset': { borderColor: 'rgba(99,102,241,0.4)' },
    '&.Mui-focused fieldset': { borderColor: '#6366F1', borderWidth: '1px' },
  },
  '& .MuiInputBase-input': { color: '#FFFFFF' },
  '& .MuiInputBase-input::placeholder': { color: '#8B92A5', opacity: 1 },
};

const EnquiryModal = ({ open, onClose, service }) => {
  const [formData, setFormData] = useState({ name: '', email: '', company: '', phone: '', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await sendEmail(formData, `Service Enquiry - ${service}`);
    if (result.success) {
      alert(`Thanks for your interest in ${service}! We'll be in touch shortly.`);
      setFormData({ name: '', email: '', company: '', phone: '', message: '' });
      onClose();
    } else {
      alert('Failed to send. Please email admin@infynihub.com directly.');
    }
  };

  const set = (f) => (e) => setFormData({ ...formData, [f]: e.target.value });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth TransitionComponent={Transition}
      PaperProps={{ sx: { bgcolor: '#1A1D27', backgroundImage: 'none', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '20px', boxShadow: '0 40px 80px rgba(0,0,0,0.7)', overflow: 'hidden' } }}
    >
      {/* Header */}
      <Box sx={{ bgcolor: '#6366F1', p: 4, position: 'relative' }}>
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 16, top: 16, color: 'white', bgcolor: 'rgba(255,255,255,0.12)', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)', transform: 'rotate(90deg)' }, transition: 'all 0.3s' }}>
          <CloseIcon />
        </IconButton>
        <Typography variant="h4" sx={{ fontWeight: 800, color: 'white', mb: 0.5, letterSpacing: '-0.01em' }}>Get Started Today</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.95rem' }}>We'll get back to you within 24 hours.</Typography>
      </Box>

      <DialogContent sx={{ p: 4 }}>
        {/* Badge */}
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.5, bgcolor: 'rgba(99,102,241,0.1)', border: '1px solid rgba(99,102,241,0.2)', px: 2.5, py: 1.5, borderRadius: '12px', mb: 4 }}>
          <CheckCircleIcon sx={{ color: '#6366F1', fontSize: 20 }} />
          <Box>
            <Typography sx={{ color: '#8B92A5', display: 'block', fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Selected Service</Typography>
            <Typography sx={{ color: '#818CF8', fontWeight: 700, fontSize: '0.95rem' }}>{service}</Typography>
          </Box>
        </Box>

        <form onSubmit={handleSubmit} id="enquiry-form">
          <Grid container spacing={2.5}>
            <Grid item xs={12} sm={6}>
              <Typography sx={{ color: '#8B92A5', mb: 1, fontWeight: 600, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Full Name *</Typography>
              <TextField fullWidth placeholder="John Doe" required value={formData.name} onChange={set('name')} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography sx={{ color: '#8B92A5', mb: 1, fontWeight: 600, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Email *</Typography>
              <TextField fullWidth placeholder="john@company.com" type="email" required value={formData.email} onChange={set('email')} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography sx={{ color: '#8B92A5', mb: 1, fontWeight: 600, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Company</Typography>
              <TextField fullWidth placeholder="Your Company" value={formData.company} onChange={set('company')} sx={fieldSx} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography sx={{ color: '#8B92A5', mb: 1, fontWeight: 600, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Phone</Typography>
              <TextField fullWidth placeholder="+60 12-345 6789" value={formData.phone} onChange={set('phone')} sx={fieldSx} />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: '#8B92A5', mb: 1, fontWeight: 600, fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Message *</Typography>
              <TextField fullWidth placeholder="Tell us about your requirements..." multiline rows={4} required value={formData.message} onChange={set('message')} sx={fieldSx} />
            </Grid>
          </Grid>
        </form>
      </DialogContent>

      <Box sx={{ px: 4, pb: 4, pt: 1, display: 'flex', gap: 2, justifyContent: 'flex-end', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
        <Button onClick={onClose} size="large" sx={{ color: '#8B92A5', px: 3, textTransform: 'none', fontWeight: 600, '&:hover': { bgcolor: 'rgba(255,255,255,0.04)' } }}>
          Cancel
        </Button>
        <Button type="submit" form="enquiry-form" variant="contained" size="large" endIcon={<ArrowForwardIcon />} sx={{
          bgcolor: '#6366F1', px: 4, py: 1.4, fontSize: '0.95rem', fontWeight: 700,
          borderRadius: '10px', textTransform: 'none',
          boxShadow: '0 4px 20px rgba(99,102,241,0.3)',
          '&:hover': { bgcolor: '#5254CC', transform: 'translateY(-2px)', boxShadow: '0 8px 28px rgba(99,102,241,0.45)' },
          transition: 'all 0.25s',
        }}>
          Submit Enquiry
        </Button>
      </Box>
    </Dialog>
  );
};

export default EnquiryModal;
